'use strict'; /* eslint-disable no-console */

const tooltip = (function() {
	// Get all the toggletip buttons

	function setupEventBindings(toggletips) {
		[].forEach.call(toggletips, (toggletip) => {

			// Get the message from the data-content element
			const message = toggletip.getAttribute('data-toggletip-content');

			// Get the live region element
			const liveRegion = toggletip.nextElementSibling;
			liveRegion.innerHTML = `<span class="tooltip__bubble">${message}</span>`;

			toggletip.addEventListener('click', (e) => {
				e.preventDefault();
				liveRegion.classList.add('active');
				liveRegion.classList.add('forced-active');
			});
			toggletip.addEventListener('blur', (e) => {
				e.preventDefault();
				liveRegion.classList.remove('active');
				liveRegion.classList.remove('forced-active');
			});
			toggletip.addEventListener('mouseenter', () => {
				liveRegion.classList.add('active');
			});
			toggletip.addEventListener('mouseleave', () => {
				liveRegion.classList.remove('active');
			});
		});
	}


	function init() {
		// setTimeout(() => {
		const toggletips = document.querySelectorAll('[data-toggletip-content]');
		setupEventBindings(toggletips);
	}

	window.addEventListener('DOMContentLoaded', init);

	/**
	 * Usage:
	 *     const reinitTooltipsEvent = new Event('ReinitTooltips');
	 *     window.dispatchEvent(reinitTooltipsEvent);
	 * Or:
	 *     window.reinitTooltips();
	 **/
	window.addEventListener('ReinitTooltips', init);
	window.reinitTooltips = init;

	return {
		init,
	}

})();

export default tooltip;



// WEBPACK FOOTER //
// ./resources/assets/js/tooltip.js